import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { MenuTextData, ProductsData } from "../models/types";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, Breadcrumbs } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    breadcrumbLink: {
      fontSize: '13px',
      textDecoration: 'none',
      color: '#000000',
      lineHeight: 1.35,
    },
  }),
);

interface PropsFromState {
  language: string;
  loading: boolean;
  errors?: string;
  products: ProductsData[];
  text: MenuTextData;
  breadCrumb: string[];
}

type AllProps = PropsFromState;

const ProductBreadcrumb: React.FC<AllProps> = ({
  language,
  loading,
  text,
  breadCrumb
}) => {

  const classes = useStyles();
  const intl = useIntl();

  return (
    <Box pb={2}>
      <Breadcrumbs separator="›" aria-label={intl.formatMessage({ id: "aria.breadcrumb" })}>
        <Link className={classes.breadcrumbLink} to={"/"} >
          <FormattedMessage id="nav.home" />
        </Link>
        {!loading ? (
          breadCrumb.map(item => (
            <Link className={classes.breadcrumbLink} to={"/product/category/" + item} >
              {text[item]?.value[language]}
            </Link>
          ))
        ) : ( null ) }
      </Breadcrumbs>
    </Box>
  );
};

const mapStateToProps = ({ language, products, menu }: ApplicationState) => ({
  language: language.language,
  loading: products.loading,
  errors: products.errors,
  products: products.products,
  text: menu.text,
  breadCrumb: menu.breadcrumb
});

export default connect(mapStateToProps)(ProductBreadcrumb);
